var map = {
	"./prism-coy.css": 85097,
	"./prism-coy.min.css": 69230,
	"./prism-dark.css": 95019,
	"./prism-dark.min.css": 69784,
	"./prism-funky.css": 94128,
	"./prism-funky.min.css": 92199,
	"./prism-okaidia.css": 89576,
	"./prism-okaidia.min.css": 64829,
	"./prism-solarizedlight.css": 4451,
	"./prism-solarizedlight.min.css": 71156,
	"./prism-tomorrow.css": 80636,
	"./prism-tomorrow.min.css": 94405,
	"./prism-twilight.css": 7525,
	"./prism-twilight.min.css": 55350,
	"./prism.css": 94720,
	"./prism.min.css": 98710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61790;